import React from "react";

import styles from "./section-wrapper.module.scss";

export const SectionWrapper: React.FC = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);
